// extracted by mini-css-extract-plugin
module.exports = {"validationTips":"_460c349","suggestions":"_e742447","suggestion":"_35af36e"};